import { Alert, Box, Link, Typography } from '@mui/material';

const MOCK = {
  casesInCaseType: 123,
  caveat: 'Missing race on 10 of 123 cases.',
  raceComposition: [
    { label: 'Black', color: '#B91C1C', share: 0.35 },
    { label: 'Hispanic', color: '#9CA3AF', share: 0.3 },
    { label: 'White', color: '#B7791F', share: 0.25 },
    { label: 'Other', color: '#2563EB', share: 0.1 },
  ],
};

function InspectCompanion() {
  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        border: '1px solid #CBD5E0',
        borderRadius: '8px',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
        padding: '20px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        boxSizing: 'border-box',
      }}
    >
      <Typography sx={{ fontSize: '11px', color: '#2D3748' }}>{'Ventura Superior Court · 2019–2025'}</Typography>
      <Box>
        <Typography sx={{ fontSize: '30px', fontWeight: 800, lineHeight: 1.1 }}>{MOCK.casesInCaseType}</Typography>
        <Typography sx={{ fontSize: '12px', color: '#4A5568' }}>cases in this case type</Typography>
      </Box>

      <Box sx={{ display: 'flex', width: '100%', height: 6, borderRadius: 3, overflow: 'hidden' }}>
        {MOCK.raceComposition.map((segment) => (
          <Box
            key={segment.label}
            title={segment.label}
            sx={{ backgroundColor: segment.color, width: `${segment.share * 100}%` }}
          />
        ))}
      </Box>

      <Alert severity='warning' icon={false} sx={{ fontSize: '12px', padding: '4px 12px', boxShadow: 'none' }}>
        {MOCK.caveat}
      </Alert>

      <Link
        component='button'
        type='button'
        underline='hover'
        sx={{ fontSize: '12px', fontWeight: 600, textAlign: 'left' }}
      >
        View full Inspect →
      </Link>
    </Box>
  );
}

export default InspectCompanion;
